import axios from "axios";
import secureLocalStorage from "react-secure-storage";
// List Of Venders
export const get_all_vendors = async () => {
  let response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/vendors");
  return response.data;
}
// List Of All Active Vendors
export const get_all_active_vendors= async () => {
  let response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/vendors/1");
  return response.data;
}
// Status Filter Vendor
   export const get_all_filters_status_vendor=async (status) => {
    const response = await axios.get(secureLocalStorage.getItem("baseURL") + '/api/vendors/'+status);
      return response.data;
  };
   export const get_all_filters_status_vendors_without_pagination=async (status) => {
    const response = await axios.post(secureLocalStorage.getItem("baseURL") + '/api/vendors/'+status);
      return response.data;
  };
// Add New supplier
export const add_vendor = async (values) => {
    let response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/vendor", values);
    return response.data;
}
//Delete Vendor Api
export const delete_vendor = async (id) => {
  let response = await axios.delete(secureLocalStorage.getItem("baseURL") + "/api/vendor/"+id);
  return response.data;
}

// Update the updateVendor function to accept an object as a parameter
export const update_vendor = async (updatedVendor) => {
  const {
    id,
    supplier_type,
    supplier_name,
    email,
    mobile_no,
    telephone,
    address_line_1,
    address_line_2,
    town,
    city,
    post_code,
    status,
  } = updatedVendor;

  try {
    const response = await axios.patch(secureLocalStorage.getItem("baseURL") + "/api/vendor/" + id, {
      supplier_type,
      supplier_name,
      email,
      mobile_no,
      telephone,
      address_line_1,
      address_line_2,
      town,
      city,
      post_code,
      status,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
// Get Single Vendor Logs by ID
export const get_vendor_logs = async (id: number) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/supplier-activity-log/" + id);
  return response.data;
};
// Get All Vendors Logs
export const get_all_vendors_logs = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/supplier-activity-logs");
  return response.data;
};
// change status 
export const change_active_status_vendor = async (id:number) => {
  let response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/update-status/" + id, {
    model_name:"supplier",
  });
  return response.data;  
}
// Single Vendor
export const get_single_vendor = async (id:number) => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/vendor/"+id);
  return response.data;
}
export const get_all_filters_status_vendors = async (
  status: string,      
  page: number,         
  itemsPerPage: number, 
) => {
  const baseURL = secureLocalStorage.getItem("baseURL");
  const apiEndpoint = "/api/vendors/"+status;
  const payload: any = {
    page: page,
    per_page: itemsPerPage,
  };
  Object.keys(payload).forEach(key => {
    if (payload[key] === "" || payload[key] === null || payload[key] === undefined) {
      delete payload[key];
    }
  });
  
  try {
    const response = await axios.post(baseURL + apiEndpoint, payload);
    return response;
  } catch (error) {
    console.error("Error fetching filtered vendors:", error);
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.message || 'Failed to fetch vendors');
    }
    throw error;
  }
};